export const isElectronEnvironment = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  return userAgent.indexOf("electron/") > -1;
};
